/**
 * Route for `custom-attribution-windows`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomAttributionWindowsPage } from "../features/custom-attribution-windows/CustomAttributionWindowsPage";

export const customAttributionWindowsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-attribution-windows",
	component: CustomAttributionWindowsPage,
});

export default customAttributionWindowsRoute;
